import React from 'react';
import styled from 'styled-components';
import directeur from '../assets/dirc.jpeg';
import sof from '../assets/Sophie.jpeg';
import thom from '../assets/thoma.jpeg';
import marie from '../assets/marie.jpeg';

const teamMembers = [
    {
      name: "Marc Dubois",
      image: directeur,
      role: "Directeur Technique"
    },
    {
      name: "Sophie Laurent",
      image: sof,
      role: "Directrice Innovation"
    },
    {
      name: "Thomas Bernard",
      image: thom,
      role: "Chef de Projet"
    },
    {
      name: "Marie Rousseau",
      image: marie,
      role: "Ingénieure R&D"
    }
  ];


const TeamSection = () => {

  
    return (
        <TeamContainer>
        {teamMembers.map((member, index) => (
          <TeamCard key={index}>
            <CardImageWrapper>
              <CardImage src={member.image} alt={member.name} />
              <CardOverlay>
                <CardInfo>
                  <CardName>{member.name}</CardName>
                  <CardRole>{member.role}</CardRole>
                </CardInfo>
              </CardOverlay>
            </CardImageWrapper>
          </TeamCard>
        ))}
      </TeamContainer>
    );
  };


  export default TeamSection;
  
  const TeamContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  width: 100%;
  padding: 4rem 0;
    margin: 15vh 0 5vh;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 2rem 0;
  }
`;

const TeamCard = styled.div`
  background: #2A2A2F;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
  }
`;



const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
`;

const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0) 50%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: flex-end;
  padding: 1.5rem;

  @media (max-width: 768px) {
    opacity: 1;
  }
`;

const CardInfo = styled.div`
  color: white;
  text-align: left;
  width: 100%;
`;

const CardName = styled.h3`
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  margin-bottom: 0.5rem;
`;

const CardRole = styled.p`
  font-size: 0.9rem;
  color: #E5E5E5;
  opacity: 0.8;
  margin: 0;
`;
const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3/4;
  overflow: hidden;

  &:hover {
    ${CardOverlay} {
      opacity: 1;
    }

    ${CardImage} {
      transform: scale(1.05);
    }
  }
`;
